import React from "react";
import { makeStyles, Container, Grid } from "@material-ui/core";

import { useQuery } from "@apollo/client";
import { useState } from "react";
import { useEffect } from "react";
import { GET_WEBTOON_PROGRAM_BY_ID } from "../../../quries/webtoon";

import WebtoonInGallery from "./WebtoonInGallery";
import MetaSeo from "../../../components/MetaSeo";

const useStyles = makeStyles((theme) => ({
  topContainer: {
    paddingTop: "10rem",
    paddingBottom: "6rem",
    [theme.breakpoints.down("xs")]: { paddingTop: "5rem" },
  },
  sidePadding: {
    paddingLeft: "6rem",
    paddingRight: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 32,
      paddingRight: 32,
    },
  },
  bigTitle: {
    fontFamily: "Noto Sans KR",
    fontSize: 64,
    color: "black",
    fontWeight: 900,
    // letterSpacing: -4,
    // display: "inline-block",
    paddingBottom: 32,
    [theme.breakpoints.down("xs")]: {
      fontSize: 32,
      paddingBottom: 16,
    }, // paddingBottom: 8,
  },
}));

interface WebToonMenuGalleryContainerProps {
  //   children: React.ReactNode | null | string | undefined;
  history: any;
  match: any;
}

function WebToonMenuGalleryContainer({
  history,
  match,
}: WebToonMenuGalleryContainerProps) {
  const classes = useStyles();

  const [webtoonProgramTitle, setWebtoonProgramTitle] = useState<any>(null);
  const [webtoonArr, setWebtoonArr] = useState<any>(null);

  const { data, loading, error } = useQuery(GET_WEBTOON_PROGRAM_BY_ID, {
    fetchPolicy: "no-cache",

    variables: {
      id: match.params.webtoon_program_id,
    },
  });

  useEffect(() => {
    if (data && data.webToonsProgram) {
      setWebtoonProgramTitle(data.webToonsProgram.title);
      setWebtoonArr(data.webToonsProgram.web_toons);
    }
    return () => {
      setWebtoonProgramTitle(null);
      setWebtoonArr(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.webToonsProgram) {
    console.log(error);
  }

  if (webtoonProgramTitle) {
    return (
      <Container
        maxWidth={false}
        disableGutters
        className={classes.topContainer}
      >
        <MetaSeo
          data={{
            title: webtoonProgramTitle,
            canonical: `http://laborbusan.or.kr/webtoon/page/${match.params.webtoon_program_id}`,
          }}
        />
        <Container
          maxWidth={"xl"}
          disableGutters={true}
          className={classes.sidePadding}
        >
          <Grid xs={12} item className={classes.bigTitle}>
            {webtoonProgramTitle}
          </Grid>
          <Grid xs={12} item container>
            <WebtoonInGallery programId={match.params.webtoon_program_id} />
          </Grid>
        </Container>
      </Container>
    );
  } else {
    return <div></div>;
  }
}

export default WebToonMenuGalleryContainer;
